module.exports = __webpack_public_path__ + "f345cdbd56081497649066ed3222880e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-down.svg
// module id = lLHp
// module chunks = 5